import React from 'react';
import { Button } from 'antd';
import styles from './dp.module.scss';
import { KoText } from 'packages/typography';
import KoImage from 'packages/image';

export default function KoDP({logo, type, fallback, width,className, height, userId, name='A', shape}) {
  let dpurl =`${logo?.length > 0 ? logo[0].url : false}`;
  return (
    <div className={`${styles.wrapper} ${shape ? styles[shape] : ''}`}>
      {dpurl ? <Button className={`${styles.btn} ${className ?className:''}`} shape={`${shape ? shape : 'circle'}`}
        icon={<KoImage fallback={fallback} isImage={true} src={dpurl} name='UserFilled'
          width={width ? width : 16} height={height ? height: 16} />}/> : <div style={{width: width ? width : 32, height: height ? height: 32}} className={`${styles.dpCircle} ${styles[name ?
            name?.charAt(0).toLowerCase() : 'a']}`}>
        <KoText className={`${styles.letter}`} text={name.charAt(0)} />
      </div>}
    </div>
  );
}
